import type {
  TMajorActionUniversalRentData,
  TPortfolioNeighborhoodId,
} from '@kapitalist/contract/types'
import type {TMillions} from '@kapitalist/contract/types/millions'
import {show$} from '@kapitalist/contract/utils/millions/copy'
import {skins} from '~/game/skins'
import {UniversalRentCard} from '~/models/game/Cards/RentCard'
import {PlayerGamePosition} from '~/models/game/GamePosition'
import type {TMajorActionUserFacingDescriptionData} from '~/models/game/MajorAction'
import MajorActionRentBase from '~/models/game/MajorActions/MajorActionRentBase'
import type Portfolio from '~/models/game/Portfolio'
import type StandardPortfolioNeighborhood from '~/models/game/PortfolioNeighborhoods/StandardPortfolioNeighborhood'
import {standardPNForIdThrows} from '~/models/game/utils'
import {inTense} from '~/utils/language'

export default class MajorActionUniversalRent extends MajorActionRentBase<TMajorActionUniversalRentData> {
  card: UniversalRentCard

  // which neighborhood was used to initiate the rent
  portfolioNeighborhood: StandardPortfolioNeighborhood
  portfolioNeighborhoodId: TPortfolioNeighborhoodId
  millionsOwed: TMillions

  constructor(data: TMajorActionUniversalRentData, portfolio: Portfolio) {
    super(data)

    this.portfolioNeighborhoodId = data.portfolioNeighborhoodId
    this.portfolioNeighborhood = standardPNForIdThrows(portfolio)(
      data.portfolioNeighborhoodId
    )
    this.millionsOwed = data.millionsOwed
    this.card = new UniversalRentCard(data.card)
  }

  public userFacingDescription({
    tense,
    skin,
    gamePosition,
  }: TMajorActionUserFacingDescriptionData): string {
    const currentPlayer =
      gamePosition instanceof PlayerGamePosition
        ? gamePosition.currentPlayer
        : undefined
    const majorActor = gamePosition.majorActorPlayer
    const color = this.portfolioNeighborhood.displayColorShort(skin)
    const W = inTense(tense)
    const dropFirstNoun = tense === 'imperativePrompt'

    const actor = dropFirstNoun
      ? undefined
      : majorActor.id === currentPlayer?.id
        ? 'You'
        : majorActor.username

    return skins[skin].gameLogDescriptions.majorActions.universalRent({
      tense,
      actor,
      chargeVerb: W(dropFirstNoun ? 'Charge' : 'charge'),
      amount: show$(this.millionsOwed),
      cardName: this.card.displayName(skin),
      color,
    })
  }
}
